import { ComponentMap } from '@cinch-nx/data-storyblok'
import { CarsCarousel, GridRows } from '../molecule-blocks'
import { atomStoryblokComponents } from './atom-storyblok-components-map'
import { OfferCard } from '../molecule-blocks/offer-card'

const moleculeStoryblokComponents: ComponentMap = {
  CarsCarousel,
  GridRows,
  OfferCard,
}

export const sharedStoryblokComponents: ComponentMap = {
  ...atomStoryblokComponents,
  ...moleculeStoryblokComponents,
}
